import { useMemo } from 'react';

/**
 * Hook to check if Republic Day theme is enabled
 * Controlled by REACT_APP_REPUBLIC_DAY_THEME_ENABLED environment variable
 * @returns {Object} { isRepublicDayMode: boolean }
 */
export const useRepublicDayTheme = () => {
  const isRepublicDayMode = useMemo(() => {
    return process.env.REACT_APP_REPUBLIC_DAY_THEME_ENABLED === 'true';
  }, []);

  return { isRepublicDayMode };
};

export default useRepublicDayTheme;
